export const DEV_ENVIRONMENT = true;

export const STATE_CITY = 'BA';

export const FILE_MAX_SIZE = 10000000; //10 Mb
export const MAX_VEHICLES_REQUEST = 20;

export const FILE_ALLOWED_EXTENSIONS = [
  'pdf',
  'doc',
  'txt',
  'jpg',
  'docx',
  'gif',
  'odt',
  'jpeg',
  'bmp',
  'xls',
  'rtf',
  'ods',
  'png',
  'jpe',
];

export const DOCUMENT_TYPES = {
  CRLV: 95,
  CERTIFICADO_VISTORIA: 125,
  LAUDO_VISTORIA: 132,
  OTHERS: 999,
  FOTO_3_4: 108,
  CARTEIRA_CONDUTOR_SUBSTITUTO: 176,
  APOSTILA_QUADRO_HORARIO: 188,
  CEPE: 199,
  APOSTILA: 182,
  TEXTO_PUBLICACAO_DIARIO_OFICIAL: 228,
  APOLICE_SEGURO: 1010,
  NOTA_FISCAL_VEICULO: 97,
  PROTOCOLO_PRIMEIRO_LICENCIAMENTO: 1011,
};

export const VEHICLE_SUBSYSTEM_VALIDATE_AGE = [1, 2, 3, 4, 5, 6, 7];

export const DOCUMENT_TYPES_DESCRIPTION = {
  [DOCUMENT_TYPES.CRLV]: {
    deTipoDocumento: 'Certificado de registro e licenciamento de veículo',
    nmTipoDocumento: 'Certificado de registro e licenciamento de veículo',
    sgTipoDocumento: 'CRLV',
  },
};

export const USERS_AUTHORITY = {
  externo: 'EXT',
  interno: 'INT',
};

export const VEHICLE_REPORT_SITUATION = {
  APROVADO: { sg: 'A', description: 'Aprovado' },
  REPROVADO: { sg: 'R', description: 'Reprovado' },
};

export const USER_SECTORS = {
  DPE_DPSE: 23,
  DQS_DFIS_COVIT: 28,
  DQS_DFIS_GEFIC: 26,
  DQS_DPLO: 29,
  INT: 99998,
  EXT: 99999,
};

export const ALERTS_TYPES = {
  CRC: 1,
  VISTORIA: 2,
  LICENCA: 3,
};

export const SYSTEM_DOC_TYPES = {
  EMPRESA: {
    key: 'EMPRESA',
    label: 'Manual do módulo de empresas',
  },
  VEICULO: {
    key: 'VEICULO',
    label: 'Manual do módulo de veículos',
  },
  LICENCA: {
    key: 'LICENCA',
    label: 'Manual do módulo de licenças',
  },
  LINHAS: {
    key: 'LINHAS',
    label: 'Manual do módulo de linhas',
  },
  EXTERNO: {
    key: 'EXTERNO',
    label: 'Manuais dos usuários para utilização do sistema',
  },
};

export const COMPANY_TYPES = {
  GAS: 24,
};

export const COMPANY_SERVICES = [3, 4, 5, 6, 7, 8];

export const TIMEZONE_OFFSET = {
  AMERICA_SAOPAULO: -180
};
